export const STATUS_THROTTLE_MS = 700;
export const STATUS_DUPLICATE_WINDOW_MS = 4_000;

export type StatusEmitState = {
  lastAnyAt: number;
  byKey: Map<string, { text: string; at: number }>;
};

export function shouldForwardStatus(
  state: StatusEmitState,
  status: { key: string; text: string },
): boolean {
  const now = Date.now();
  const lastForKey = state.byKey.get(status.key);
  if (
    lastForKey &&
    lastForKey.text === status.text &&
    now - lastForKey.at < STATUS_DUPLICATE_WINDOW_MS
  ) {
    return false;
  }
  if (now - state.lastAnyAt < STATUS_THROTTLE_MS) {
    return false;
  }
  state.lastAnyAt = now;
  state.byKey.set(status.key, { text: status.text, at: now });
  return true;
}
